module.exports = __webpack_public_path__ + "img/icon_check_3.f32144e5.png";